// Dashboard
import { dashboardGoals, dashboardGoalsConfig } from './dashboard.goals.js'

export default function dashboardGoalsRoutes($stateProvider) {
  'ngInject'
  $stateProvider.state(dashboardGoals, dashboardGoalsConfig)
}
